"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupBy = void 0;
var react_1 = __importStar(require("react"));
var remote_1 = require("../../../remote");
var Banners_1 = __importDefault(require("./Banners"));
exports.groupBy = function (data, lookUp, exclude) {
    if (exclude === void 0) { exclude = false; }
    return data === null || data === void 0 ? void 0 : data.reduce(function (acc, cur) {
        var found = lookUp === null || lookUp === void 0 ? void 0 : lookUp.find(function (d) { return d === cur.status; });
        if (exclude ? !found : found) {
            acc = acc + cur.count;
        }
        return acc;
    }, 0);
};
exports.default = (function () {
    var _a, _b, _c;
    // const { __initialState: { assetUrlBase } }: any = window
    var assetUrlBase = "https://cdn.inkcloud9.com/mt-alpha/printribe/p/";
    var _d = react_1.useState([]), data = _d[0], setData = _d[1];
    var _e = react_1.useState(null), customerOrderStats = _e[0], setCustomerOrderStats = _e[1];
    react_1.useEffect(function () {
        var loadStats = function () { return __awaiter(void 0, void 0, void 0, function () {
            var res, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, remote_1.getStats()];
                    case 1:
                        res = _a.sent();
                        setData(res === null || res === void 0 ? void 0 : res.data);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var loadCustomerOrderStats = function () { return __awaiter(void 0, void 0, void 0, function () {
            var res, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, remote_1.getCustomerOrderStats()];
                    case 1:
                        res = _a.sent();
                        setCustomerOrderStats(res === null || res === void 0 ? void 0 : res.data);
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        console.error(e_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        loadStats();
        loadCustomerOrderStats();
    }, []);
    var newStatus = exports.groupBy(data, [
        "OK_TO_PRINT",
        "FILES_RECEIVED",
        "FILES_NOT_RECEIVED"
    ]);
    var shippedStatus = exports.groupBy(data, ["DISPATCHED"]);
    var needsAttentionStatus = exports.groupBy(data, ["ARTWORK_EXCEPTION"]);
    var productionStatus = exports.groupBy(data, [
        "OK_TO_PRINT",
        "FILES_RECEIVED",
        "FILES_NOT_RECEIVED",
        "DISPATCHED",
        "ARTWORK_EXCEPTION"
    ], true);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Banners_1.default, null),
        react_1.default.createElement("div", { className: "card mb-3" },
            react_1.default.createElement("div", { className: "card-header bg-primary txc-white" },
                react_1.default.createElement("i", { className: "fas fa-chart-line mr-2" }),
                " ",
                react_1.default.createElement("span", null, "30 Days Order")),
            react_1.default.createElement("div", { className: "card-body" },
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement("div", { className: "col-12 col-md-4" },
                        react_1.default.createElement("span", { className: "icon-container bg-light-blue" },
                            react_1.default.createElement("i", { className: "far fa-file-alt" })),
                        " ",
                        "Orders",
                        react_1.default.createElement("div", { className: "h2" }, (_a = customerOrderStats === null || customerOrderStats === void 0 ? void 0 : customerOrderStats.ordersCount) !== null && _a !== void 0 ? _a : "00")),
                    react_1.default.createElement("div", { className: "col-12 col-md-4" },
                        react_1.default.createElement("span", { className: "icon-container bg-light-pink txc-pink" },
                            react_1.default.createElement("i", { className: "fas fa-shopping-bag" })),
                        " ",
                        "Sold Products",
                        react_1.default.createElement("div", { className: "h2" }, (_b = customerOrderStats === null || customerOrderStats === void 0 ? void 0 : customerOrderStats.orderItemsCount) !== null && _b !== void 0 ? _b : "00")),
                    react_1.default.createElement("div", { className: "col-12 col-md-4" },
                        react_1.default.createElement("span", { className: "icon-container bg-light-green txc-green" },
                            react_1.default.createElement("i", { className: "fas fa-dollar-sign" })),
                        " ",
                        "Production Cost",
                        react_1.default.createElement("div", { className: "h2" }, (_c = customerOrderStats === null || customerOrderStats === void 0 ? void 0 : customerOrderStats.invoicesTotal) !== null && _c !== void 0 ? _c : "00"))))),
        react_1.default.createElement("div", { className: "card mb-3" },
            react_1.default.createElement("div", { className: "card-header bg-primary txc-white" },
                react_1.default.createElement("div", { className: "d-flex justify-content-between" },
                    react_1.default.createElement("div", { className: "d-flex align-items-center" },
                        react_1.default.createElement("i", { className: "fas fa-chart-line mr-2" }),
                        " ",
                        react_1.default.createElement("span", null, "Order Status Snapshot")),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("a", { href: "/account/order-history", className: "btn btn-outline-tertiary btn-sm" }, "View Orders")))),
            react_1.default.createElement("div", { className: "card-body" },
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement("div", { className: "col-12 col-md-3" },
                        react_1.default.createElement("span", { className: "icon-container bg-light-blue" },
                            react_1.default.createElement("i", { className: "fas fa-plus-circle" })),
                        " ",
                        "New",
                        react_1.default.createElement("div", { className: "h2" }, newStatus || "00")),
                    react_1.default.createElement("div", { className: "col-12 col-md-3" },
                        react_1.default.createElement("span", { className: "icon-container bg-light-blue txc-blue" },
                            react_1.default.createElement("i", { className: "fas fa-cogs" })),
                        " ",
                        "In Production",
                        react_1.default.createElement("div", { className: "h2" }, productionStatus || "00")),
                    react_1.default.createElement("div", { className: "col-12 col-md-3" },
                        react_1.default.createElement("span", { className: "icon-container bg-light-pink txc-pink" },
                            react_1.default.createElement("i", { className: "fas fa-exclamation-circle" })),
                        " ",
                        "Needs Attention",
                        react_1.default.createElement("div", { className: "h2" }, needsAttentionStatus || "00")),
                    react_1.default.createElement("div", { className: "col-12 col-md-3" },
                        react_1.default.createElement("span", { className: "icon-container bg-light-green txc-green" },
                            react_1.default.createElement("i", { className: "fas fa-truck" })),
                        " ",
                        "Shipped",
                        react_1.default.createElement("div", { className: "h2" }, shippedStatus || "00"))))),
        react_1.default.createElement("div", { className: "card mb-3" },
            react_1.default.createElement("div", { className: "card-header bg-primary txc-white" },
                react_1.default.createElement("div", { className: "d-flex justify-content-between" },
                    react_1.default.createElement("div", { className: "d-flex align-items-center" },
                        react_1.default.createElement("i", { className: "fas fa-box mr-2" }),
                        " Trending Products"),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("a", { href: "/products", className: "btn btn-outline-tertiary btn-sm" }, "Show All Products")))),
            react_1.default.createElement("div", { className: "card-body" },
                react_1.default.createElement("p", null, "Want to know what\u2019s trending right now in the world of Australian art? Here\u2019s some of our artist best-sellers, favourite finishes and top picks for the season."),
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement("div", { className: "col-12 col-md-4" },
                        react_1.default.createElement("div", { className: "mb-3" },
                            react_1.default.createElement("img", { src: assetUrlBase + "images/TIGHT_MOULDING_2.jpeg", alt: "" })),
                        react_1.default.createElement("h4", { className: "h3" }, "Contemporary Frames"),
                        react_1.default.createElement("p", null, "Sustainably sourced oak and Meranti timber with a soft matte, open-grain finish")),
                    react_1.default.createElement("div", { className: "col-12 col-md-4" },
                        react_1.default.createElement("div", { className: "mb-3" },
                            react_1.default.createElement("img", { src: assetUrlBase + "images/MAT_BLUE.jpeg", alt: "" })),
                        react_1.default.createElement("h4", { className: "h3" }, "Gallery Quality Matboard"),
                        react_1.default.createElement("p", null, "Crisp, white standard or conservation-grade matboard focalises the artwork")),
                    react_1.default.createElement("div", { className: "col-12 col-md-4" },
                        react_1.default.createElement("div", { className: "mb-3" },
                            react_1.default.createElement("img", { src: assetUrlBase + "images/ANTI-REFLECTIVE.jpeg", alt: "" })),
                        react_1.default.createElement("h4", { className: "h3" }, "Anti-Reflective Acrylic"),
                        react_1.default.createElement("p", null, "Premium, transparent acrylic diffuses light transfer, removing unwanted glare")))))));
});
